import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config } from '../../constants';
import ConfigItemComponent from "./ConfigItemComponent";


function closePop(){
    const pop = document.getElementById("sanctionsdocument-data-viewer")
    pop.style.display = "none"
}


export default class ParserConfigListComponent extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
            configs:[{"a":"b"}],
            sancdocs:[],                 
        }

        this.getLists()
    }

    setSancdocs = (sancdocs) =>{
        
        this.setState({sancdocs:sancdocs.sancdocs});
        document.getElementById("sanctionsdocument-data-viewer").style.display = "block";
        
    }

    getLists(){
        axios.get(config.API_URL + "parser-controller/get-parse-configs", {headers: authHeader()}).then(
            response => {
                const configs = response.data;
                
                const items = configs.map(
                    data => {
                        return <ConfigItemComponent data={data} setSancdocs={this.setSancdocs} />
                    }
                ) 

                this.setState({items:items})
            }
        )
    }

    render(){
        
    
        return(
            <>
            <div className='index-list-container'>
                <a href='/add-parser' className='add-parser-page-btn'>Add Parser</a>
                <div className='index-list-header'>

                    <p style={{width:"6%"}}>Name</p>
                    <p style={{width:"3%"}}>Source</p>
                    <p style={{width:"2%"}}>Short Name</p>
                    <p style={{width:"2%"}}>Data Type</p>
                    <p style={{width:"32%"}}>URL</p>
                    <p style={{width:"2%"}}>Edit</p>
                    <p style={{width:"2%"}}>Test</p>
                    <p style={{width:"2%"}}>Apply</p>

                </div>

                {this.state.items}

            </div>

            <div id='sanctionsdocument-data-viewer'>
                <button className='close-btn' onClick={closePop}>x</button>
                {this.state.sancdocs}
            </div>
            </>
        );
    }
}